import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const PagesContext = createContext(null);

export function PagesProvider({ children }) {
  const [pages, setPages] = useState([]);

  const load = useCallback(() => {
    api.get("/pages").then((r) => setPages(r.data || [])).catch(() => setPages([]));
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <PagesContext.Provider value={{ pages, reload: load }}>
      {children}
    </PagesContext.Provider>
  );
}

export function usePages() {
  const c = useContext(PagesContext);
  if (!c) throw new Error("usePages must be used within PagesProvider");
  return c;
}
